<template>
    <div class="absolute" id="scene" style="z-index: 2; left: 0; top: 0;">
        <div class="circle blurred circle-one-position"
             data-depth="0.3"
             id="layer_5"
             style="width: 166px; height: 166px;"
        ></div>
        <div class="circle circle-two-position"
             data-depth="0.3"
             id="layer_2"
             style="width: 24px; height: 24px;"
        ></div>
        <div class="circle-three-position"
             data-depth="0.3"
             id="layer_1"
             style="width: 24px; height: 24px; border-radius: 50%; box-shadow: 0 0 0 1px #00EBE8;"
        ></div>
        <div class="dots-position"
             data-depth="0.3"
             id="layer_7"
        >
            <div :key="index" class="leading-none text-white"
                 style="color: rgba(255,255,255,0.6); letter-spacing: 12px; line-height: 1.3;"
                 v-for="(dots, index) of 9"
            >
                •••••••••
            </div>
        </div>
        <div class="circle circle-four-position"
             data-depth="0.3"
             id="layer_3"
             style="width: 33px; height: 33px; background-color: rgba(255,255,255,0.6)"
        ></div>
        <div class="circle circle-five-position"
             data-depth="0.3"
             id="layer_4"
             style="width: 51px; height: 51px;"
        ></div>
        <div class="circle circle-six-position"
             data-depth="0.3"
             id="layer_8"
             style="width: 24px; height: 24px; opacity: 0.4;"
        ></div>
        <div class="line-position"
             data-depth="0.3"
             id="layer_6"
             style="width: 117px; height: 222px;"
        >
            <div :key="index" :style="index > 0 ? `top: ${20 * index}px` : ''" class="line"
                 v-for="(line, index) of 11"></div>
        </div>
    </div>
</template>

<script>
    import Parallax from "parallax-js";

    export default {
        name: "ParallaxShapesHome",
        data: () => ({
            parallax: null,
        }),
        mounted() {
            this.$nextTick(() => {
                let scene = document.getElementById('scene');
                this.parallax = new Parallax(scene, {
                    scalarX: 80,
                    scalarY: 70
                });
            });
        },
        beforeDestroy() {
            this.parallax.destroy();
        }
    }
</script>

<style scoped>
    .circle {
        border-radius: 50%;
        box-shadow: 0 0 0 1px rgba(255, 255, 255, 1);
    }

    .blurred {
        filter: blur(3px);
    }

    .line {
        position: absolute;
        width: 100%;
        height: 1px;
        background-color: white;
    }

    .line-position {
        opacity: 0.5;
    }

    .circle-one-position{
        top: 569px !important;
    }

    .circle-two-position{
        top: 540px !important;
    }

    .circle-three-position {
        top: 738px !important;
    }

    @media only screen and (max-width: 600px) {
        .circle-one-position {
            opacity: 0;/*Off screen, no need to display*/
        }

        .circle-two-position {
            opacity: 0;/*Off screen, no need to display*/
        }

        .circle-three-position {
            opacity: 0;/*Off screen, no need to display*/
        }

        .circle-four-position {
            opacity: 0;/*Off screen, no need to display*/
        }

        .circle-five-position {
            opacity: 0;/*Off screen, no need to display*/
        }

        .circle-six-position{
            left: -100px !important;/*Off screen, no need to display*/
        }

        .line-position{
            left: 295px !important;
            top: 54px !important;
            width: 97px !important;
        }

        .dots-position {
            opacity: 0;/*Off screen, no need to display*/
        }
    }

    @media only screen and (min-width: 601px) and (max-width: 639px) {
        .circle-one-position {
            opacity: 0;/*Off screen, no need to display*/
        }

        .circle-two-position {
            opacity: 0;/*Off screen, no need to display*/
        }

        .circle-three-position {
            opacity: 0;/*Off screen, no need to display*/
        }

        .circle-four-position {
            opacity: 0;/*Off screen, no need to display*/
        }

        .circle-five-position {
            opacity: 0;/*Off screen, no need to display*/
        }

        .circle-six-position{
            left: -100px !important;/*Off screen, no need to display*/
        }

        .line-position{
            left: 325px !important;
            top: 54px !important;
            width: 97px !important;
        }

        .dots-position {
            opacity: 0;/*Off screen, no need to display*/
        }
    }

    @media only screen and (min-width: 640px) and (max-width: 660px) {
        .circle-one-position {
            opacity: 0;/*Off screen, no need to display*/
        }

        .circle-two-position {
            opacity: 0;/*Off screen, no need to display*/
        }

        .circle-three-position {
            opacity: 0;/*Off screen, no need to display*/
        }

        .circle-four-position {
            opacity: 0;/*Off screen, no need to display*/
        }

        .circle-five-position {
            opacity: 0;/*Off screen, no need to display*/
        }

        .circle-six-position{
            left: -100px !important;/*Off screen, no need to display*/
        }

        .line-position{
            left: 395px !important;
            top: 54px !important;
        }

        .dots-position {
            opacity: 0;/*Off screen, no need to display*/
        }
    }

    @media only screen and (min-width: 661px) and (max-width: 800px) {
        .circle-one-position {
            opacity: 0;/*Off screen, no need to display*/
        }

        .circle-two-position {
            opacity: 0;/*Off screen, no need to display*/
        }

        .circle-three-position {
            left: 315px !important;
            top: 900px !important;
        }

        .circle-four-position {
            left: 520px !important;
            top: 114px !important;
        }

        .circle-five-position {
            left: 494px !important;
            top: 131px !important;
        }

        .circle-six-position{
            left: 636px !important;
            top: 451px !important;
        }

        .line-position{
            opacity: 0;/*Off screen, no need to display*/
        }

        .dots-position {
            left: 673px !important;
            top: 248px !important;
        }
    }

    @media only screen and (min-width: 801px) and (max-width: 900px) {
        .circle-one-position {
            opacity: 0;/*Off screen, no need to display*/
        }

        .circle-two-position {
            opacity: 0;/*Off screen, no need to display*/
        }

        .circle-three-position {
            left: 415px !important;
            top: 838px !important;
        }

        .circle-four-position {
            left: 520px !important;
            top: 114px !important;
        }

        .circle-five-position {
            left: 494px !important;
            top: 131px !important;
        }

        .circle-six-position{
            left: 636px !important;
            top: 451px !important;
        }

        .line-position{
            opacity: 0;/*Off screen, no need to display*/
        }

        .dots-position {
            left: 673px !important;
            top: 248px !important;
        }
    }

    @media only screen and (min-width: 901px) and (max-width: 1100px) {
        .circle-one-position {
            opacity: 0;/*Off screen, no need to display*/
        }

        .circle-two-position {
            opacity: 0;/*Off screen, no need to display*/
        }

        .circle-three-position {
            left: 515px !important;
            top: 838px !important;
        }

        .circle-four-position {
            left: 920px !important;
            top: 214px !important;
        }

        .circle-five-position {
            left: 894px !important;
            top: 231px !important;
        }

        .circle-six-position{
            left: 636px !important;
            top: 451px !important;
        }

        .line-position{
            opacity: 0;/*Off screen, no need to display*/
        }

        .dots-position {
            left: 673px !important;
            top: 248px !important;
        }
    }

    @media only screen and (min-width: 1101px) and (max-width: 1500px) {
        .circle-one-position {
            opacity: 0;/*Off screen, no need to display*/
        }

        .circle-two-position {
            opacity: 0;/*Off screen, no need to display*/
        }

        .circle-three-position {
            left: 715px !important;
            top: 838px !important;
        }

        .circle-four-position {
            left: 920px !important;
            top: 214px !important;
        }

        .circle-five-position {
            left: 894px !important;
            top: 231px !important;
        }

        .circle-six-position{
            left: 636px !important;
            top: 451px !important;
        }

        .line-position{
            left: 1280px !important;
            top: 41px !important;
        }

        .dots-position {
            left: 673px !important;
            top: 248px !important;
        }
    }

    @media only screen and (min-width: 1501px) and (max-width: 1600px) {
        .circle-one-position {
            opacity: 0;/*Off screen, no need to display*/
        }

        .circle-two-position {
            opacity: 0;/*Off screen, no need to display*/
        }

        .circle-three-position {
            left: 815px !important;
        }

        .circle-four-position {
            left: 920px !important;
            top: 214px !important;
        }

        .circle-five-position {
            left: 894px !important;
            top: 231px !important;
        }

        .circle-six-position{
            left: 636px !important;
            top: 451px !important;
        }

        .line-position{
            left: 1380px !important;
            top: 41px !important;
        }

        .dots-position {
            left: 673px !important;
            top: 248px !important;
        }
    }

    @media only screen and (min-width: 1601px) and (max-width: 1639px) {
        .circle-one-position {
            opacity: 0;/*Off screen, no need to display*/
        }

        .circle-two-position {
            opacity: 0;/*Off screen, no need to display*/
        }

        .circle-three-position {
            left: 915px !important;
        }

        .circle-four-position {
            left: 1020px !important;
            top: 214px !important;
        }

        .circle-five-position {
            left: 994px !important;
            top: 231px !important;
        }

        .circle-six-position{
            left: 736px !important;
            top: 451px !important;
        }

        .line-position{
            left: 1480px !important;
            top: 41px !important;
        }

        .dots-position {
            left: 773px !important;
            top: 248px !important;
        }
    }


    @media only screen and (min-width: 1640px) {
        .circle-one-position {
            left: -71px !important;
        }

        .circle-two-position {
            left: 51px !important;
        }

        .circle-three-position {
            left: 1015px !important;
        }

        .circle-four-position {
            left: 1120px !important;
            top: 214px !important;
        }

        .circle-five-position {
            left: 1094px !important;
            top: 231px !important;
        }

        .circle-six-position{
            left: 836px !important;
            top: 451px !important;
        }

        .line-position{
            left: 1580px !important;
            top: 41px !important;
        }

        .dots-position {
            left: 873px !important;
            top: 248px !important;
        }
    }
</style>